import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const STATUS_STYLES = {
  "Submitted": "bg-gray-100 text-gray-900 border-gray-300",
  "Under Review": "bg-amber-50 text-amber-900 border-amber-300",
  "Reviewed": "bg-blue-50 text-blue-900 border-blue-300",
  "Denied": "bg-red-50 text-red-900 border-red-300",
  "Rejected": "bg-red-50 text-red-900 border-red-300",
  "Interview": "bg-emerald-50 text-emerald-900 border-emerald-300",
  "Further Assessment": "bg-indigo-50 text-indigo-900 border-indigo-300",
  "On Hold": "bg-orange-50 text-orange-900 border-orange-300",
  "Accepted": "bg-green-100 text-green-900 border-green-400",
  "Flagged": "bg-rose-50 text-rose-900 border-rose-300",
};

export const ALL_STATUSES = [
  "Submitted","Under Review","Reviewed","Rejected","Interview",
  "Further Assessment","On Hold","Accepted","Flagged"
];
